export const environment = {
  production: true,
  apiUrl: 'https://summerry-bff-sb2k3nfvta-ez.a.run.app/api',
  backendUrl: 'https://summerry-bff-sb2k3nfvta-ez.a.run.app',
  legalDocs: {
    initialPublish: '2025-01-01T00:00:00Z',
    lastUpdated: '2025-05-18T00:00:00Z',
  },
  canonicalOrigin: 'https://summerry.com',
};
